/**
 * VenueRegionField — the Region picker on the venue create drawer and the
 * venue page. Lists only the regions the viewer may write to.
 */
import type { RegionNode } from '../../../api/regions';
import RegionTreeSelect from '../../../shared/RegionTreeSelect';
import { FixedField } from '../primitives/FixedField';

export function VenueRegionField({
  regions,
  loading,
  failed,
  value,
  error,
  clearLabel,
  onChange,
}: {
  regions: RegionNode[];
  loading: boolean;
  failed: boolean;
  value: string;
  error?: string;
  /** Label for the empty choice; omit to offer no empty choice. */
  clearLabel?: string;
  onChange: (regionId: string) => void;
}) {
  if (loading) {
    return <FixedField label="Region" value="Loading regions…" ariaLabel="Region (loading)" />;
  }
  if (failed) {
    return (
      <FixedField label="Region" value="Couldn’t load regions" ariaLabel="Region (unavailable)" />
    );
  }
  if (regions.length === 0) {
    return <FixedField label="Region" value="No regions available" ariaLabel="Region (none)" />;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span
        id="venue-region-label"
        style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}
      >
        Region
      </span>
      <RegionTreeSelect
        regions={regions}
        value={value}
        onChange={onChange}
        placeholder="Select a region…"
        clearLabel={clearLabel}
        variant="dashboards"
        aria-labelledby="venue-region-label"
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? 'venue-region-error' : undefined}
      />
      {error && (
        <span id="venue-region-error" style={{ fontSize: 10.5, color: 'var(--nb-risk)' }}>
          {error}
        </span>
      )}
    </div>
  );
}
